"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queueMicrotask = queueMicrotask;
const monitor_1 = require("./monitor");
const globalObject_1 = require("./globalObject");
function queueMicrotask(callback) {
    var _a;
    const nativeImplementation = (_a = globalObject_1.globalObject.queueMicrotask) === null || _a === void 0 ? void 0 : _a.bind(globalObject_1.globalObject);
    if (typeof nativeImplementation === 'function') {
        nativeImplementation((0, monitor_1.monitor)(callback));
    }
    else {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises -- the callback is monitored, so it'll never throw
        Promise.resolve().then((0, monitor_1.monitor)(callback));
    }
}
//# sourceMappingURL=queueMicrotask.js.map